/**
 * Created by dyc on 2018/4/10.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Tabs,
  Upload,
  Icon,
  Radio,
  Cascader,
  Select,
  message,
} from 'antd';
import {
  DmsTab,
  RichEditor,
} from 'Components';
import {
  openNotice,
  APIS,
  proLineSet,
  config,
  showSpin,
  hideSpin,
} from 'Utils';
import {
  getProductDetails,
  saveProductEdit,
  getSpecListByFujian,
  fetchSpecList,
} from '../../service/product';
import { categoryTree } from '../../service/category';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const Option = Select.Option;
const specPrefix = '$radioVal@';

class ProductAdd extends React.Component {
  constructor(props) {
    super(props);
    this.id = props.params.productId === '0' ? 0 : props.params.productId;
    this.state = {
      opts: [],
      button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end')),
      files: [],
      fileTotal: '',
      btnLoad: false,
      detail: {},
      defaultActiveKey: 1,
      abbImgData: {
        'id': '',
        'thumbUrl': '',
      },
      /* 略缩图 */
      abbProps: {
        action: APIS.upload,
        onChange: this.updateAbbImg.bind(this),
        listType: 'picture',
        showUploadList: false,
        defaultFileList: [],
        className: 'upload-img-only',
      },
      mainImgLi: [], /* 主图 */
      mainProps: {	/* 轮播图 */
        action: APIS.upload,
        onChange: this.updateMainImg.bind(this),
        listType: 'picture',
        showUploadList: false,
        defaultFileList: [],
        className: 'upload-img-only',
      },
      informationProps: {	/* 产品资料 */
        name: 'file',
        action: APIS.upload,
        onChange: this.updateInformation.bind(this),
        showUploadList: false,
        defaultFileList: [],
      },
      informationLi: [],
      /* 产品参数 */
      htmlParamContent: '',
      /* 图文详情 */
      imageTextContent: '',
      loadingSpec: false,
      visibleSpec: false,
      /////
      productSpecList: [], // 规格属性列表
      showBelongCategory: false, // 如果是配件，则允许编辑所属分类输入框。
      tree: [],
      treeCache: [],
    };
    this.initData = this.initData.bind(this);
  }

  goView(url) {
    hashHistory.push(url);
  }

  updateHtmlFn(field, htmlText) {
    // console.log(field)
    //       console.log(htmlText)
    // 富文本
    this.setState({
      [field]: htmlText,
    });
  }

  cancelHandle() {
    hashHistory.goBack();
  }

  submitHandle() {
    let self = this;
    const { validateFields, getFieldsValue } = self.props.form;
    const { detail, abbImgData, mainImgLi, informationLi, imageTextContent, htmlParamContent, productSpecList } = self.state;
    if(productSpecList.every(x => !x.value)) {
      message.error('请设置规格属性');
      return
    }
    validateFields((errors) => {//表单校验
      if (errors) {
        self.setState({
          'btnLoad': false,
        });
        return;
      }//表单校验有误，则不执行下面的代码
      const saveData = {
        ...getFieldsValue(), //获取用户输入
      };
      if (!abbImgData.id) {
        openNotice('warning', '请上传产品略缩图', '');
        self.setState({
          'btnLoad': false,
        });
        return;
      }
      saveData.picId = abbImgData.id;
      if (mainImgLi.length == 0) {
        openNotice('warning', '请上传产品主图', '');
        self.setState({
          'btnLoad': false,
        });
        return;
      }
      let picIds = [];
      for (let imgData of mainImgLi) {
        picIds.push({
          // 'fileId': imgData.id
          'attachId': imgData.id,
        });
      }
      saveData.picIds = picIds;
      /*附件*/
      let fileList = [];
      for (let informationData of informationLi) {
        fileList.push({
          // 'fileId': informationData.id
          'attachId': informationData.id,
        });
      }
      saveData.fileList = fileList;
      saveData.graphicDetails = imageTextContent || '';
      saveData.parameter = htmlParamContent || '';

      // belongCategory
      saveData.proBigType = saveData.belongCategory[0]; // 分类大类code
      saveData.proMiddleType = saveData.belongCategory[1]; // 分类中类code
      saveData.proDetailType = saveData.belongCategory[2]; // 分类小类code
      delete saveData.belongCategory;
      if(detail.proBigType === config['配件类编码']){
        //fujianList
        saveData.fujianList = productSpecList.filter(x => !!x.propertyDescName).map(x => ({
          categoryId: x.categoryId,
          // propertyNum: x.propertyNum,
          propertyName: x.propertyName,
          propertyCategoryCode: x.propertyCategoryCode,
          propertyDescName: x.value
        }));
        // saveData.specValue = productSpecList.filter(x => !!x.propertyDescName && !!x.value).map(x => `${x.propertyName}&${x.value}`).sort((a, b) => a.localeCompare(b, 'zh-CN')).join('@');
        saveData.specValue = productSpecList.filter(x => !!x.propertyDescName && !!x.value).map(x => `${x.propertyName}&${x.value}`).join('@');
        saveData.propertyCategoryCode = '附件';
      } else {
        // bentiList
        saveData.bentiList = productSpecList.filter(x => !!x.propertyDescName).map(x => ({
          categoryId: x.categoryId,
          // propertyNum: x.propertyNum,
          propertyName: x.propertyName,
          propertyCategoryCode: x.propertyCategoryCode,
          propertyDescName: x.value
        }));
        // saveData.specValue = productSpecList.filter(x => !!x.propertyDescName && !!x.value).map(x => `${x.propertyName}&${x.value}`).sort((a, b) => a.localeCompare(b, 'zh-CN')).join('@');
        saveData.specValue = productSpecList.filter(x => !!x.propertyDescName && !!x.value).map(x => `${x.propertyName}&${x.value}`).join('@');
        saveData.propertyCategoryCode = '本体';
      }
      self.setState({
        'btnLoad': true,
      });
      showSpin();
      /* 编辑 */
      saveData.id = detail.id;
      saveProductEdit(saveData).then(function (result) {
        hideSpin();
        self.setState({
          'btnLoad': false,
        });
        if (result && result.status == true) {
          openNotice('success', '产品保存成功', '');
          window.history.go(-1);
        } else {
          openNotice('error', '产品保存失败', (result && result.message) ? result.message : '');
        }
      });
    });
  }

  tabClickFn(key) {
    /* 页签点击 */
    this.setState({ defaultActiveKey: key });
  }

  initData() {
    categoryTree({ id: 1 }).then(result => {
      if (result.status) {
        const filterEmpty = (list) => list.map(x => {
          let key = x.code; // 实际使用的业务数据是 code；
          if (x.children && x.children.length) {
            return {
              ...x,
              key: key, // 使用实际业务数据重新给 key 赋值
              value: key, // 使用实际业务数据重新给 value 赋值
              isLeaf: false,
              children: filterEmpty(x.children),
            };
          }
          return {
            ...x,
            key: key,
            value: key,
            isLeaf: true,
            children: undefined,
          };
        });
        let list = filterEmpty(result.data || []);
        this.setState({
          treeCache: filterEmpty(result.data || []),
          tree: list.filter(x => /配件/.test(x.label)), // 只展示配件
        });
      } else {
        message.error(result.message);
      }
    });
  }

  componentDidMount() {
    let self = this;
    this.initData();
    /*获取详情数据*/
    if(this.id) {
      getProductDetails({ id: this.id }).then(function (result) {
        if (result && result.code == 200) {
          let detail = result.data || {};
          let currentSpecValues = {}; // 当前本体的规格值集合
          detail.categoryPathId = detail.categoryPathId ? detail.categoryPathId.replace(/\./g, ',') : '';
          detail.categoryText = detail.categoryText ? detail.categoryText.replace(/\./g, ',') : '';
          detail.belongCategory = detail.categoryPathId.split(',').filter(x => !!x);
          if(detail.proBigType === config['配件类编码']) {
            if (detail.categoryTypeVo && detail.categoryTypeVo.fujianMsg && detail.categoryTypeVo.fujianMsg.length) {
              detail.categoryTypeVo.fujianMsg.filter(x => !!x).forEach(x => {
                currentSpecValues[`${specPrefix}${x.categoryId}@${x.propertyName}`] = x.propertyDesc;
              });
            }
          } else {
            if (detail.categoryTypeVo && detail.categoryTypeVo.bentiMsg && detail.categoryTypeVo.bentiMsg.length) {
              detail.categoryTypeVo.bentiMsg.filter(x => !!x).forEach(x => {
                currentSpecValues[`${specPrefix}${x.categoryId}@${x.propertyName}`] = x.propertyDesc;
              });
            }
          }
          self.getProductSpecConfigList(detail.realCategoryId, detail.propertyCategoryCode, currentSpecValues).then(specList => {
            self.setState({
              opts: ['编辑产品'],
              productSpecList: specList,
              showBelongCategory: detail.proBigType === config['配件类编码'], // 如果是配件，则展示所属分类输入框。
              detail: detail,
              'abbImgData': { /* 产品略缩图 */
                ...self.state.abbImgData,
                'id': detail.picId,
                'thumbUrl': detail.picUrl,
              },
              'mainImgLi': detail.picUrls, /* 产品主图 */
              'imageTextContent': detail.graphicDetails, /* 图文详情 */
              'htmlParamContent': detail.parameter,/* 产品参数 */
              'informationLi': detail.fileUrls, /* 产品资料 */
            });
          })
          /*if(detail.proBigType === config['配件类编码']) {
            productSpecList = detail.itemCategory.fujianMsg;
            if (detail.categoryTypeVo && detail.categoryTypeVo.fujianMsg && detail.categoryTypeVo.fujianMsg.length) {
              detail.categoryTypeVo.fujianMsg.filter(x => !!x).forEach(x => {
                // currentSpecValues[`${specPrefix}${x.categoryId}@${x.propertyNum}`] = x.propertyDesc;
                currentSpecValues[`${specPrefix}${x.categoryId}@${x.propertyName}`] = x.propertyDesc;
              });
            }
            specList = productSpecList.map(x => {
              // let filedName = `${specPrefix}${x.categoryId}@${x.propertyNum}`;
              let filedName = `${specPrefix}${x.categoryId}@${x.propertyName}`;
              return {
                ...x,
                key: filedName, // 设置字段名称
                value: currentSpecValues[filedName], // 用当前附件的规格值，设置字段的默认值
              };
            });
          } else {
            productSpecList = detail.itemCategory.bentiMsg;
            if (detail.categoryTypeVo && detail.categoryTypeVo.bentiMsg && detail.categoryTypeVo.bentiMsg.length) {
              detail.categoryTypeVo.bentiMsg.filter(x => !!x).forEach(x => {
                // currentSpecValues[`${specPrefix}${x.categoryId}@${x.propertyNum}`] = x.propertyDesc;
                currentSpecValues[`${specPrefix}${x.categoryId}@${x.propertyName}`] = x.propertyDesc;
              });
            }
            specList = productSpecList.map(x => {
              // let filedName = `${specPrefix}${x.categoryId}@${x.propertyNum}`;
              let filedName = `${specPrefix}${x.categoryId}@${x.propertyName}`;
              return {
                ...x,
                key: filedName, // 设置字段名称
                value: currentSpecValues[filedName], // 用当前附件的规格值，设置字段的默认值
              };
            });
          }*/
        } else {
          openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
        }
      });
    }
  }
  getProductSpecConfigList = (categoryId, propertyCategoryCode, currentSpecValues) => {
    return new Promise((resolve, reject) => {
      fetchSpecList(categoryId).then(result => {
        if (result.status && result.code == 200) {
          const data = result.data;
          let specList = [];
          if(propertyCategoryCode === '本体') {
            specList = (data.bentiMsg || []).map(x => {
              let filedName = `${specPrefix}${x.categoryId}@${x.propertyName}`;
              return {
                ...x,
                key: filedName, // 设置字段名称
                value: currentSpecValues[filedName], // 用当前附件的规格值，设置字段的默认值
              };
            });
          }
          if(propertyCategoryCode === '附件') {
            specList = (data.fujianMsg || []).map(x => {
              let filedName = `${specPrefix}${x.categoryId}@${x.propertyName}`;
              return {
                ...x,
                key: filedName, // 设置字段名称
                value: currentSpecValues[filedName], // 用当前附件的规格值，设置字段的默认值
              };
            });
          }
          resolve(specList)
        } else {
          openNotice('error', '获取规格失败', result.message || '');
        }
      });
    })
  }
  // 本体规格接口
  getProductSpecList = (categoryId) => new Promise((resolve, reject) => {
    if(!this.state.showBelongCategory) {
      reject(new Error('只有附件才能变更所属分类'))
      return
    }
    getSpecListByFujian({categoryId}).then(result => {
      if (result.status && result.code == 200) {
        let list = (result.data || []).map(x => {
          // let filedName = `${specPrefix}${x.categoryId}@${x.propertyNum}`;
          let filedName = `${specPrefix}${x.categoryId}@${x.propertyName}`;
          return {
            ...x,
            key: filedName, // 设置字段名称
            value: undefined, // 用当前附件的规格值，设置字段的默认值
          };
        });
        this.setState({
          productSpecList: list, // 本体
        }, () => {
          resolve();
        });
      } else {
        openNotice('error', '获取本体规格失败', result.message || '');
        reject(new Error('获取本体规格失败'));
      }
    });
  });

  stopUp(e) {
    e.stopPropagation();
  }

  updateAbbImg(result) {
    /* 略缩图更新 */
    if (result.file.status === 'done') {
      let responseData = result.file.response || {};
      if (responseData.code != 200) {
        openNotice('error', '图片上传失败');
        return;
      }
      this.setState({
        abbImgData: {
          ...this.state.abbImgData,
          id: responseData.data.id,
          thumbUrl: responseData.data.fileCompressPath,
        },
      });
    }
  }

  deleteAbbImg() {
    /* 删除略缩图 */
    this.setState({
      abbImgData: {
        ...this.state.abbImgData,
        id: '',
        thumbUrl: '',
      },
    });
  }

  updateMainImg(result) {
    /* 主图更新 */
    let mainImgLi = this.state.mainImgLi || [];
    if (result.file.status === 'done') {
      let responseData = result.file.response || {};
      if (responseData.code != 200) {
        openNotice('error', '图片上传失败');
        return;
      }
      mainImgLi.push({
        id: responseData.data.id,
        fileCompressPath: responseData.data.fileCompressPath,
      });
    }
    this.setState({
      mainImgLi: mainImgLi,
    });
  }

  deleteMainImg(index) {
    /* 删除主图 */
    const { mainImgLi } = this.state;
    mainImgLi.splice(index, 1);
    this.setState({
      mainImgLi: mainImgLi,
    });
  };

  /*产品资料*/
  updateInformation(result) {
    let informationLi = this.state.informationLi || [];
    if (result.file.status === 'done') {
      let responseData = result.file.response || {};
      if (responseData.code != 200) {
        openNotice('error', '附件上传失败');
        return;
      }
      informationLi.push({
        id: responseData.data.id,
        fileName: responseData.data.fileName,
      });
    }
    this.setState({
      informationLi: informationLi,
    });
  };

  deleteInformation(index) {
    /* 删除产品资料 */
    const { informationLi } = this.state;
    informationLi.splice(index, 1);
    this.setState({
      informationLi: informationLi,
    });
  };

  // 本体规格切换
  bentiSpecChange = (value, name) => {
    const { productSpecList } = this.state;
    // const [prefix, categoryId, propertyNum] = name.split('@');
    const [prefix, categoryId, propertyName] = name.split('@');
    // console.log('debug prefix, categoryId, propertyNum: ', prefix, categoryId, propertyNum);
    console.log('debug prefix, categoryId, propertyName: ', prefix, categoryId, propertyName);
    let list = productSpecList.map(x => ({
      ...x,
      categoryId: x.categoryId,
      // propertyNum: x.propertyNum,
      // value: x.propertyNum === propertyNum ? value : x.value,
      value: x.propertyName === propertyName ? value : x.value,
    }));
    this.setState({
      productSpecList: list,
    });
  };

  CascaderFilter = (inputValue, path) => {
    return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
  };
  render() {
    let self = this;
    const {
      btnLoad, detail, button_limits_end, defaultActiveKey, abbImgData,
      abbProps, mainImgLi, mainProps, informationProps, informationLi,
      productSpecList, showBelongCategory, treeCache,
    } = this.state;
    const { getFieldDecorator, setFields } = this.props.form;
    const treeData = showBelongCategory ? treeCache.filter(x => /配件/.test(x.label)) : treeCache.filter(x => !/配件/.test(x.label))
    let mainImgHtml = (mainImgLi || []).map(function (qst, key) {
      return <div className="edit_upload_img" key={key}>
        <img src={config.server + qst.fileCompressPath} alt="" />
        <i className="anticon anticon-delete" onClick={self.deleteMainImg.bind(self, key)}></i>
      </div>;
    });
    let informationHtml = (informationLi || []).map(function (ele, key) {
      return <div className="edit_upload_information" key={key}>
        <span>{ele.fileName}</span>
        <i className="anticon anticon-delete" onClick={self.deleteInformation.bind(self, key)}></i>
      </div>;
    });
    const radioLayout = { marginLeft: 10 };
    const radioButtonLayout = { marginRight: 10, marginBottom: 10 };
    const specRender = (list, changeHandle) => (list).map((ele, index, arr) => {
      var radioOptionsRenderer = (ele.propertyDescName || []).map((e, i) => {
        let _className = '';
        if (arr.length) {
          for (let i = 0; i < arr.length; i++) {
            // if (ele.propertyNum == arr[i].propertyNum) {
            if (ele.propertyName == arr[i].propertyName) {
              let _str = ',' + arr[i].propertyDescName + ',';
              _className = _str.indexOf(',' + e + ',') != -1 ? '' : 'grayBtn';
              break;
            }
          }
        }
        return <RadioButton
          style={radioButtonLayout}
          key={i}
          id={ele.id}
          tag="ben"
          propertyNum={ele.propertyNum}
          value={e}
          className={_className}
        >{e}
        </RadioButton>;
      });
      return (
        <div key={index}
             className="dms-spec-radio-group">
          {(index > 0) && <div className="dms-split-bar" />}
          <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
            <Icon type="logout" style={{ paddingLeft: '1px' }} />
            &emsp;{ele.propertyName}
          </div>
          <RadioGroup
            name={ele.key}
            value={ele.value}
            style={radioLayout}
            onChange={(e) => changeHandle(e.target.value, ele.key)}>
            {radioOptionsRenderer}
            {/* &emsp;<span onClick={() => changeHandle(undefined, ele.key)}><Icon type="close-circle-o" /></span> */}
          </RadioGroup>
        </div>
      );
    });
    return <div className="dms-body">
      <DmsTab options={self.state.opts} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        {button_limits_end.product_add_01 &&
        <Button type='primary' loading={btnLoad} onClick={this.submitHandle.bind(this)}>保存</Button>}
      </DmsTab>

      <div className="tab_individual add_product">
        <Tabs className="my-ant-tabs" defaultActiveKey={defaultActiveKey + ''} onChange={this.tabClickFn.bind(this)}>
          <TabPane tab="基础信息" key="1">
            <div style={{ padding: '12px', background: '#fff' }}>
              <Form layout="horizontal">
                <Row gutter={16}>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="物料编码：" hasFeedback>
                      {getFieldDecorator('itemNum', {
                        initialValue: detail.itemNum || '',
                        rules: [
                          {
                            required: false,
                            message: '请输入物料编码',
                          },
                        ],
                      })(<Input disabled />)}
                    </FormItem>
                  </Col>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="物料大类：" hasFeedback>
                      {getFieldDecorator('proBigName', {
                        initialValue: detail.proBigName || '',
                        rules: [
                          {
                            required: false,
                            message: '请输入物料大类',
                          },
                        ],
                      })(<Input disabled />)}
                    </FormItem>
                  </Col>
                </Row>
                <div>
                  <div style={{ display: 'none' }}>
                    {/*  categoryId*/}
                    <FormItem label="物料所属分类第三级分类Id：" hasFeedback>
                      {getFieldDecorator('categoryId', {
                        initialValue: detail.categoryId ? detail.categoryId : '',
                        rules: [
                          {
                            required: true,
                            message: '请选择所属分类',
                          },
                        ],
                      })(<Input />)}
                    </FormItem>
                  </div>
                  <div style={{ display: 'none' }}>
                    {/*  categoryId*/}
                    <FormItem label="物料实际分类Id：" hasFeedback>
                      {getFieldDecorator('realCategoryId', {
                        initialValue: detail.realCategoryId ? detail.realCategoryId : '',
                        rules: [
                          {
                            required: true,
                            message: '请选择所属分类',
                          },
                        ],
                      })(<Input />)}
                    </FormItem>
                  </div>
                  <FormItem label="所属分类：" hasFeedback>
                    {getFieldDecorator('belongCategory', {
                      initialValue: detail.belongCategory ? detail.belongCategory : [],
                      rules: [
                        {
                          required: true,
                          message: '请选择所属分类',
                        },
                      ],
                      getValueFromEvent: (value, selectedOptions) => {
                        let lastOption = selectedOptions && selectedOptions.length ? selectedOptions[selectedOptions.length -1] : {};
                        let threeLevel = selectedOptions && selectedOptions[2] ? selectedOptions[2] : {};
                        setFields({
                          realCategoryId: {
                            value: lastOption.categoryId || '',
                            errors: undefined,
                          },
                          categoryId: {
                            value: threeLevel.categoryId || '',
                            errors: undefined,
                          },
                        });
                        if(showBelongCategory) {
                          this.getProductSpecList(lastOption.categoryId || '');
                        }
                        return value;
                      },
                    })(<Cascader
                      options={treeData}
                      disabled={!showBelongCategory}
                      placeholder="请选择所属分类"
                      showSearch={{ filter: this.CascaderFilter }}
                    />)}
                  </FormItem>
                </div>
                <Row gutter={16}>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="单位：" hasFeedback>
                      {getFieldDecorator('unit', {
                        initialValue: detail.unit || '',
                        rules: [
                          {
                            required: false,
                            message: '请输入单位',
                          },
                        ],
                      })(<Input disabled />)}
                    </FormItem>
                  </Col>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="库存类型：" hasFeedback>
                      {getFieldDecorator('stockType', {
                        initialValue: detail.stockType || '',
                        rules: [
                          {
                            required: false,
                            message: '请输入库存类型',
                          },
                        ],
                      })(<Input disabled />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="最小装箱数：" hasFeedback>
                      {getFieldDecorator('minPackageQuantity', {
                        initialValue: detail.minPackageQuantity || '',
                        rules: [
                          {
                            required: false,
                            message: '请输入最小装箱数',
                          },
                        ],
                      })(<Input disabled />)}
                    </FormItem>
                  </Col>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="最小起订量：" hasFeedback>
                      {getFieldDecorator('minOrderQuantity', {
                        initialValue: detail.minOrderQuantity || '',
                        rules: [
                          {
                            required: false,
                            message: '请输入最小起订量',
                          },
                        ],
                      })(<Input disabled />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="装箱数：" hasFeedback>
                      {getFieldDecorator('packageQuantity', {
                        initialValue: detail.packageQuantity || '',
                        rules: [
                          {
                            required: false,
                            message: '请输入装箱数',
                          },
                        ],
                      })(<Input disabled />)}
                    </FormItem>
                  </Col>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="产品线：" hasFeedback>
                      {getFieldDecorator('proLine', {
                        initialValue: detail.proLine || '',
                        rules: [
                          {
                            required: false,
                            message: '请输入产品线',
                          },
                        ],
                      })(<Select disabled>
                        {
                          proLineSet.map(x => <Option key={x.value}>{x.text}</Option>)
                        }
                      </Select>)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="物料名称：" hasFeedback>
                      {getFieldDecorator('name', {
                        initialValue: detail.name || '',
                        rules: [
                          {
                            required: false,
                            message: '请输入物料名称',
                          },
                        ],
                      })(<Input disabled />)}
                    </FormItem>
                  </Col>
                  <Col className="gutter-row" span={12}>
                    <FormItem label="牌价：" hasFeedback>
                      {getFieldDecorator('showPrice', {
                        initialValue: detail.showPrice || '',
                        rules: [
                          {
                            required: false,
                            message: '请输入牌价',
                          },
                        ],
                      })(<Input disabled />)}
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            </div>
          </TabPane>
          <TabPane tab="规格属性" key="spec">
            <div style={{ padding: '12px', background: '#fff' }}>
              {specRender(productSpecList || [], this.bentiSpecChange)}
            </div>
          </TabPane>
          <TabPane tab="图文详情" key="2">
            <div style={{ padding: '16px 12px', background: '#fff' }}>
              <div className="upload_add_pro">
                <Upload {...abbProps}>
                  <span className="ti" onClick={self.stopUp.bind(self)}>产品略缩图<font>*</font></span>
                  <Button style={{ display: !abbImgData.id || abbImgData.length == 0 ? 'inline-block' : 'none' }}>选择图片文件</Button>
                  <span className="hint" onClick={self.stopUp.bind(self)}>建议图片大小 : 360x235px</span>
                </Upload>
                <div className="edit_upload_img"
                     style={{ display: !abbImgData.id || abbImgData.length == 0 ? 'none' : 'block' }}>
                  <img src={config.server + abbImgData.thumbUrl} alt="" />
                  <i className="anticon anticon-delete" onClick={self.deleteAbbImg.bind(self)}></i>
                </div>
              </div>
              <div className="upload_add_pro">
                <Upload {...mainProps}>
                  <span className="ti" onClick={self.stopUp.bind(self)}>产品主图<font>*</font></span>
                  <Button style={{ display: mainImgLi.length == 5 ? 'none' : 'inline-block' }}>选择图片文件</Button>
                  <span className="hint" onClick={self.stopUp.bind(self)}>最多可上传5张图片 , 建议图片大小 : 360x235px</span>
                </Upload>
                {mainImgHtml}
              </div>
              <div className="image_text">
                <p>图文详情</p>
                <RichEditor htmlContent={this.state.imageTextContent}
                            onChange={this.updateHtmlFn.bind(this, 'imageTextContent')} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="产品参数" key="3">
            <div style={{ padding: '12px', background: '#fff' }}>
              <div id="productParamText">
                <RichEditor htmlContent={this.state.htmlParamContent}
                            onChange={this.updateHtmlFn.bind(this, 'htmlParamContent')} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="产品资料" key="4">
            <div style={{ padding: '12px', background: '#fff' }}>
              <label>附件：</label>
              <Upload {...informationProps} >
                <Button>
                  <Icon type="upload" /> 上传附件
                </Button>
              </Upload>
              {informationHtml}
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>;
  }
}

export default Form.create()(ProductAdd);



// WEBPACK FOOTER //
// ./src/routes/product/add.js